import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import CertificateSection from "../../mylearning/certificate-section";
import { useCertificateContext } from "@root/context/certificate-context";
import { useEffect } from "react";
import { Paginate } from "@root/components/pagination";
import { RECORDS_PER_PAGE } from "@root/constants";
import { useTranslation } from "react-i18next";

const CertificateTab = () => {
  const {
    allCertificatesData,
    fetchALlJCertificates,
    certificatePageNo,
    setCertificatePageNo,
    certificatePageCount,
    aLlCertificatesLoading,
  } = useCertificateContext();
  const { t } = useTranslation("common");

  useEffect(() => {
    fetchALlJCertificates({ status: "completed" }, certificatePageNo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certificatePageNo]);

  const handlePageChange = (newPage: number) => {
    setCertificatePageNo(newPage);
  };

  if (aLlCertificatesLoading) {
    return <Spinner size={"lg"} mt={"150px"} />;
  }
  if (!allCertificatesData?.rows?.length) {
    return (
      <Text color={"#5C6670"} mt={"150px"}>
        {t("course.noDataFound")}
      </Text>
    );
  }

  return (
    <Box w="100%" gap="16px" display="flex" flexDirection="column">
      {allCertificatesData?.rows?.map((cert: any, idx: number) => (
        <CertificateSection key={idx} certificate={cert} />
      ))}
      {/* Pagination */}
      {certificatePageCount > 0 && (
        <Box mt={6} display="flex" justifyContent="center">
          <Paginate
            marginTop={0}
            page={certificatePageNo}
            count={certificatePageCount}
            pageSize={RECORDS_PER_PAGE}
            onPageChange={handlePageChange}
            variant="ghost"
          />
        </Box>
      )}
    </Box>
  );
};

export default CertificateTab;
